import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardSimpleSharedComponent } from './card-simple.component';

@NgModule({
    declarations: [
        CardSimpleSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        CardSimpleSharedComponent
    ],
})

export class CardSimpleSharedModule {}
